import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  const products = [
    {
      name: "ChipServer Essential",
      price: "$345",
      description: "Perfect for personal use, designed for users who want a simple and efficient way to store and share files directly from their ChipServer.",
      features: [
        "128GB internal storage",
        "Up to 400 Mbp/s upload speed",
        "Support for 15+ simultaneous users",
        "50ft+ uninterrupted range"
      ],
      storeLink: "/store/#!/ChipServer-Essential/p/733423279"
    },
    {
      name: "ChipServer Plus",
      price: "$495",
      description: "A versatile solution for both professional and personal environments, offering enhanced connectivity and external storage options.",
      features: [
        "1 USB port included",
        "Compatible with USB type A/3.0 drives",
        "Support for 15+ simultaneous users",
        "External SSD support"
      ],
      storeLink: "/store/#!/ChipServer-Plus/p/733423280"
    },
    {
      name: "ChipServer Pro",
      price: "$895",
      description: "Our most powerful model, designed for professional environments requiring maximum storage and connectivity capabilities.",
      features: [
        "256GB Internal Storage + USB port",
        "Up to 400 Mbp/s upload speed",
        "Support for 25+ simultaneous users",
        "80ft+ uninterrupted range"
      ],
      storeLink: "/store/#!/ChipServer-Pro/p/733423542"
    }
  ];

  return (
    <div id="pricing" className="pricing-section">
      <h2 className="pricing-title">But What's the Price?</h2>
      <div className="no-subscription-badge">NO SUBSCRIPTIONS NEEDED</div>
      <div className="pricing-container">
        {products.map((product, index) => (
          <Link 
            to={product.storeLink} 
            key={index} 
            className="pricing-card-link"
          >
            <div className="pricing-card">
              <h3>{product.name}</h3>
              <div className="price" translate="no">
                {product.price}
              </div>
              <p className="description">{product.description}</p>
              <ul className="features-list">
                {product.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
              <div className="buy-now-button">Buy Now</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Pricing; 